import { useCallback, useEffect } from 'react';
import { CopySources } from 'src/types';
import { useAppDispatch, useAppSelector } from 'universal-scripts';

export const useSuccessToast = () => {
	const dispatch = useAppDispatch();
	const openSuccessToast = (message: string) => dispatch({ type: 'success/show', payload: message });

	const closeSuccessToast = useCallback(() => dispatch({ type: 'success/hide' }), [dispatch]);
	const successMessage = useAppSelector((s) => s.successToast);

	const handleCopy = async (source: Required<CopySources>, text: string) => {
		await navigator?.clipboard.writeText(text);
		openSuccessToast(source as string);
	};

	useEffect(() => {
		const id = setTimeout(closeSuccessToast, 1500);
		return () => clearTimeout(id);
	}, [successMessage, closeSuccessToast]);

	return {
		successMessage,
		closeSuccessToast,
		handleCopy,
		openSuccessToast
	};
};
